import React from 'react'
import { Link } from 'react-router-dom'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { IconButton } from '@mui/material'

type DataTableOpenPanelButtonProps = {
    accessibleLabel: string
    disabled?: boolean
    onClick?: () => void
    to?: string
}

const sx = { p: 1, color: 'figma.primary', '&.Mui-disabled': { color: 'figma.grayscale.tier4' } }

export const DataTableOpenPanelButton = ({
    accessibleLabel,
    disabled = false,
    onClick,
    to,
}: DataTableOpenPanelButtonProps) =>
    to ? (
        <IconButton
            component={Link}
            to={to}
            aria-label={accessibleLabel}
            disabled={disabled}
            onClick={(event: React.MouseEvent) => event.stopPropagation()}
            sx={sx}
        >
            <ArrowForwardIosIcon fontSize="small" color="inherit" />
        </IconButton>
    ) : (
        <IconButton
            aria-label={accessibleLabel}
            disabled={disabled}
            onClick={(event) => {
                event.stopPropagation()
                onClick?.()
            }}
            sx={sx}
        >
            <ArrowForwardIosIcon fontSize="small" color="inherit" />
        </IconButton>
    )

export default DataTableOpenPanelButton
